/*eslint-disable */
// import SpcmCalenderModel from '../../Model/SpcmCalender'
import request from '../../Utils/curl'

let SpcmCalenders = {
  /**
   * spcmCalendarList
   */
  async spcmCalendarList (context, payload=null) {
    try{
      let post_data = new FormData();  
      if (payload) {
        for(const key in payload) {
          if (payload[key] || typeof payload[key] == 'number') {
            post_data.append(key, payload[key])
          }
        }
      }

      return await request.curl(context, "spcm_calendar_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at spcmCalendarList() and Exception:',err.message)
    }
  },

  /**
   * spcm Calendar Console List
   */
  async spcmCalendarConsoleList (context, whereFilter=null) {
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        if (whereFilter.student_id == 'null') {
          delete whereFilter.student_id
        }

        if (whereFilter.counsellor_id == 'null') {
          delete whereFilter.counsellor_id
        }


        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_calendar_console_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at spcmCalendarList() and Exception:',err.message)
    }
  },

  /**
   * spcmCalendarView
   */
  async spcmCalendarView (context, spcmCalendarId, userId = null) {
    try {      
      let post_data = new FormData();
      post_data.append('spcm_calendar_id', spcmCalendarId);

      // Use current user_id if not explicitly provided
      if (userId) {
        post_data.append('user_id', userId);
      }
      else if (context.userData && context.userData.user_id) {
        post_data.append('user_id', context.userData.user_id);
      }

      return await request.curl(context, "spcm_calendar_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at spcmCalendarView() and Exception:",err.message)
    }    
  },

  /**
   * spcmCalendarAdd
   */
  async spcmCalendarAdd (context, spcmCalendarObj) {
    try{
      let post_data = new FormData();
    
      for (let key in spcmCalendarObj) {
        post_data.append(key, spcmCalendarObj[key]);
      }

      return await request.curl(context, "spcm_calendar_bulk_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at spcmCalendarAdd() and Exception:',err.message)
    }
  },

  /**
   * spcmCalendarEdit
   */
  async spcmCalendarEdit (context, spcmCalendarObj) {
    try{
      let post_data = new FormData();
    
      for (let key in spcmCalendarObj) {
        post_data.append(key, spcmCalendarObj[key]);
      }

      return await request.curl(context, "spcm_calendar_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at spcmCalendarEdit() and Exception:',err.message)
    }
  },

  /**
   * spcmCalendarDelete
   */
  async spcmCalendarDelete (context, spcmCalendarId) {
    try {
      let post_data = new FormData();
      
      post_data.append('spcm_calendar_id', spcmCalendarId);
      post_data.append('user_id', context.userData.user_id);
      post_data.append('pid', 'CAL_DELETE');

      return await request.curl(context, "spcm_calendar_delete", post_data)
        .then(response => {
          return response;
        });
    }
    catch(err) {
      console.log('Exception occurred at spcmCalendarDelete() and Exception:', err.message);
    }
  },
   /**
   * spcm Student Distinct Counsellor Filter List
   */
  async spcmStudentDistinctCounsellorFilterList (context, filterObj) {
    try {
      let postData = new FormData();
      postData.append("user_id", filterObj.counsellor_id); 
      
      return await request.curl(context, "spcm_student_distinct_counsellor_filter_list", postData)
        .then(response => {
          return response;
        });
    }
    catch (err) {
      console.error("Exception in spcmStudentDistinctCounsellorFilterList:", err.message);
    }
  },
  /**
   * spcm Calendar Last Id
   */
  async spcmCalendarLastId (context, Filter=null) {
    try{
      let post_data = new FormData();  
      if (Filter) {
        post_data.append('filter', JSON.stringify(Filter))
      }
      return await request.curl(context, "spcm_calendar_last_id", post_data)
        .then(response => {
          return response;
        });
    }
    catch (err) {
      console.error("Exception in spcmCalendarLastId:", err.message);
    }
  }
}

export {
  SpcmCalenders
}
